import React, { Component } from "react";
import IndiaMap from "../map/IndiaMap";

class StateWise extends Component {
  render() {
    return (
      <React.Fragment>
        <IndiaMap />
      </React.Fragment>
    );
  }
}

export default StateWise;
